/**
 * Date formatting utilities shared across the obstruction wizard.
 *
 * Produces locale-independent `YYYY-MM-DDTHH:mm` strings for storage in
 * Mantine form values, and parses them back to `Date` for the date pickers.
 * Uses local (wall-clock) time — no timezone shifting.
 */

/** Format a `Date` (or ISO string) as `YYYY-MM-DDTHH:mm` for `DateTimePicker`. */
export function dateToIsoLocal(value: Date | string | null | undefined): string {
  if (!value) return '';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day}T${hours}:${minutes}`;
}

/** Parse a `YYYY-MM-DDTHH:mm` string back to a `Date`, or return `null`. */
export function isoLocalToDate(value: string): Date | null {
  if (!value) return null;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}
